import { createActionGroup, emptyProps } from '@ngrx/store';

export const initActions = createActionGroup({
  source: 'Init',
  events: {
    'Init App': emptyProps(),
  },
});
